import PropTypes from 'prop-types';
import React, { Component } from 'react';

class ProgressCircle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current: props.percentage,
            target: props.percentage,
        };
    }

    componentDidMount() {
        this.animate();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            shouldStartNewAnimation: true,
            target: nextProps.percentage,
        });
    }

    componentDidUpdate() {
        if (this.state.shouldStartNewAnimation) {
            this.setState({
                shouldStartNewAnimation: false,
            });

            this.animate();
        }
    }

    animate() {
        if (this.state.target > this.state.current) {
            this.setState({
                current: this.state.current + 0.5,
                request: window.requestAnimationFrame(this.animate.bind(this)),
            });
        } else if (this.state.target < this.state.current) {
            this.setState({
                current: this.state.current - 0.5,
                request: window.requestAnimationFrame(this.animate.bind(this)),
            });
        }
    }

    render() {
        return (
            <div className="progress-circle">
                <div className="progress-circle__percentage">{Math.ceil(this.state.current)}%</div>
                <div className="progress-circle__circle">
                    <svg
                        className="progress-circle__circle__background-svg"
                        width="100%"
                        height="100%"
                    >
                        <circle r="16" cx="50%" cy="50%" />
                    </svg>
                    <svg
                        className="progress-circle__circle__progress-svg"
                        width="100%"
                        height="100%"
                    >
                        <circle
                            r="16"
                            cx="50%"
                            cy="50%"
                            style={{ strokeDasharray: `${this.state.current} 100` }}
                        />
                    </svg>
                </div>
            </div>
        );
    }
}

ProgressCircle.propTypes = {
    percentage: PropTypes.number.isRequired,
};

export default ProgressCircle;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/progress-circle.jsx